import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadAlerts = () => {
  return getData(`${getConfig('alertsUrl')}`);
};
